import {
    defineNuxtRouteMiddleware,
    navigateTo,
} from 'nuxt/app';
import routes from '@routes';

export default defineNuxtRouteMiddleware(() => {
    return navigateTo({ name: routes.myRequests });
});
  